/** Deterministic initials from a display name; '?' for empty/unknown. */
export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/**
 * SC-423: a user's name as the pickers and filter chips show it - deactivated users are marked
 * so an assignment left on one is recognisable.
 */
export function formatUserLabel(user: { fullName: string; isActive: boolean }): string {
  return user.isActive ? user.fullName : `${user.fullName} (inactive)`;
}
